import { Queue } from '@rossum/api-client/queues';
import { ColumnsPanel } from '../../document-list-column-config/ColumnsPanel';
import { useCustomizeColumns } from '../../document-list-column-config/hooks/useCustomizeColumns';
import {
  MetaColDef,
  SchemaColDef,
} from '../../document-list-columns/TypedGridColDef';
import { AllDocsAnnotation } from '../types';

type Props = {
  columns: Array<
    SchemaColDef<AllDocsAnnotation> | MetaColDef<AllDocsAnnotation>
  >;
  selectionActive: boolean;
  activeQueue: Queue | null;
};

export const ActionsColumnHeader = ({
  columns,
  selectionActive,
  activeQueue,
}: Props) => {
  const { handleAddColumn, handleRemoveColumn, updateColumns } =
    useCustomizeColumns({ columns, activeQueue });

  return (
    <ColumnsPanel
      selectionActive={selectionActive}
      columns={columns}
      activeQueue={activeQueue}
      handleAddColumn={handleAddColumn}
      handleRemoveColumn={handleRemoveColumn}
      updateColumns={updateColumns}
      size="small"
    />
  );
};
